module.exports = __webpack_public_path__ + "img/contribute_5.c2ad91ca.png";